/* loaded by smart-asset */
export default require("./add-24px~JWUZUtnd.svg")